/*
 |-----------------------------------------------------------------------------
 | El primer pintado
 |-----------------------------------------------------------------------------
 | Sin esto, entrar en el dominio de un estudio enseña NUESTRO azul durante un
 | instante y luego salta a su color. En un producto que vende «con tu nombre»,
 | ese parpadeo es la marca equivocada en la pantalla equivocada — y con ~80 ms
 | de ida y vuelta hasta Lima más el arranque de la SPA, dura lo suficiente para
 | verse.
 |
 | No hay forma de resolverlo del todo desde el cliente: el tema depende del
 | dominio y el dominio sólo lo sabe el servidor, que aquí sirve un HTML
 | estático. Lo que sí se puede es no equivocarse dos veces seguidas.
 */

import { applyTheme, type Branding } from './apply'
import { recallBranding } from './storage'
import { isMarketingHost } from '../lib/host'

/**
 * Tema neutro: los grises del tema claro y ningún color de marca.
 *
 * Es lo que se pinta la PRIMERA vez que alguien entra en el dominio de un
 * estudio, cuando todavía no hay nada cacheado. No acierta, pero tampoco
 * miente: es preferible un instante sin color a un instante con el color de
 * otro. Los botones salen grises hasta que llega la marca, no azules.
 */
const NEUTRAL: Branding = { primary_color: '#4a4a4d', theme: 'editorial' }

/**
 * La identidad de ChasquiTambo. Tinta sobre papel, sin color propio.
 *
 * El «color de marca» es una tinta cálida casi negra: el motor deriva de ahí
 * unos neutros con ese matiz —papel, no blanco de pantalla— y unos botones que
 * son bloques de tinta. La única nota saturada de la web acaba siendo el demo
 * de temas, donde aparecen los colores de los estudios.
 */
const CHASQUITAMBO: Branding = { primary_color: '#1a1613', theme: 'marketing' }

/**
 * Aplica el tema ANTES del primer render.
 *
 * Se llama desde `main.tsx` y de forma síncrona a propósito: en cuanto React
 * pinta, ya es tarde. El branding real llega después por la red y se vuelve a
 * aplicar; si coincide con lo cacheado —el caso normal a partir de la segunda
 * visita— no se ve nada.
 *
 * En el host de marketing aplica NUESTRA identidad y ahí se acaba: esa web no
 * pertenece a ningún estudio y no hay nada que consultar por la red, así que se
 * pinta bien desde el primer fotograma.
 */
export function primeTheme(): void {
  // Sin `remember` en ninguno de los dos casos: no es información nueva. En
  // marketing porque es una constante, y en un tenant porque volver a
  // escribirla renovaría el neutro por encima de un branding real si la red
  // falla en la primera visita.
  applyTheme(isMarketingHost() ? CHASQUITAMBO : (recallBranding() ?? NEUTRAL), false)
}
